import React from 'react';
import SIcon from './SIcon';
import { faBadgeCheck } from '@fortawesome/pro-regular-svg-icons';

const Icon = props => <SIcon {...props} icon={faBadgeCheck} fa />;

export default Icon;
